import { produce } from "immer";
import {
    // Pre-order Summary
    PRE_ORDER_EVENT_OVERVIEW_REQUEST,
    PRE_ORDER_EVENT_OVERVIEW_SUCCESS,
    PRE_ORDER_EVENT_OVERVIEW_FAILURE,

    PRE_ORDER_BY_ORDER_DATE_REQUEST,
    PRE_ORDER_BY_ORDER_DATE_SUCCESS,
    PRE_ORDER_BY_ORDER_DATE_FAILURE,

    PRE_ORDER_BY_PICKUP_SLOT_REQUEST,
    PRE_ORDER_BY_PICKUP_SLOT_SUCCESS,
    PRE_ORDER_BY_PICKUP_SLOT_FAILURE,

    PRE_ORDERS_BY_CHANNELS_REQUEST,
    PRE_ORDERS_BY_CHANNELS_SUCCESS,
    PRE_ORDERS_BY_CHANNELS_FAILURE,

    // Pre-order Details
    PRE_ORDER_DETAILS_REQUEST,
    PRE_ORDER_DETAILS_SUCCESS,
    PRE_ORDER_DETAILS_FAILURE,
    EVENT_NAME_FILTER_VALUES_REQUEST,
    EVENT_NAME_FILTER_VALUES_SUCCESS,
    EVENT_NAME_FILTER_VALUES_FAILURE,

    EVENT_PRE_ORDER_BY_PICKUP_SLOT_DATE_REQUEST,
    EVENT_NAME_GOLBAL,
    EVENT_DATES,
    EVENT_START_DATE,
    EVENT_END_DATE,
    EVENT_SELECTED_DATE_FILTER_TYPE,
    EVENT_SLOTS_FILTER_REQUEST,
    EVENT_SLOTS_FILTER_SUCCESS,
    EVENT_SLOTS_FILTER_FAILURE,
    EVENT_SELECTED_TIME_SLOT,
    PRE_ORDER_SUMMARY_GLOBAL_START_DATE,
    PRE_ORDER_SUMMARY_GLOBAL_END_DATE,
    PRE_ORDER_SUMMARY_GLOBAL_SELECTED_DATE_FILTER_TYPE,
} from "./eventReportsConstants";
import moment from "moment";

const initialState = {
    todaysEventOverviewLoading: false,
    todaysEventOverviewData: [],
    todaysEventOverviewError: false,

    todaysEventVolumeBySessionLoading: false,
    todaysEventVolumeBySessionData: [],
    todaysEventVolumeBySessionError: false,

    todaysAssignedEventLoading: false,
    todaysAssignedEventData: [],
    todaysAssignedEventError: false,

    todaysUpcomingEventLoading: false,
    todaysUpcomingEventData: [],
    todaysUpcomingEventError: false,

    upcomingEventOverviewLoading: false,
    upcomingEventOverviewData: [],
    upcomingEventOverviewError: false,

    upcomingEventVolumeBySessionLoading: false,
    upcomingEventVolumeBySessionData: [],
    upcomingEventVolumeBySessionError: false,

    upcomingEventVolumeLoading: false,
    upcomingEventVolumeData: [],
    upcomingEventVolumeError: false,

    upcomingEventBySessionLoading: false,
    upcomingEventBySessionData: [],
    upcomingEventBySessionError: false,

    upcomingEventStatusByDateLoading: false,
    upcomingEventStatusByDateData: [],
    upcomingEventStatusByDateError: false,

    upcomingEventCancellationByReasonsLoading: false,
    upcomingEventCancellationByReasonsData: [],
    upcomingEventCancellationByReasonsError: false,

    upcomingEventDetailsLoading: false,
    upcomingEventDetailsData: [],
    upcomingEventDetailsError: false,

    eventOverviewLoading: false,
    eventOverviewData: [],
    eventOverviewError: false,

    eventOverviewSlotWiseEventLoading: false,
    eventOverviewSlotWiseEventData: [],
    eventOverviewSlotWiseEventError: false,

    eventOverviewDailyEventsGuestsLoading: false,
    eventOverviewDailyEventsGuestsData: [],
    eventOverviewDailyEventsGuestsError: false,

    eventOverviewDineInDurationByGroupsLoading: false,
    eventOverviewDineInDurationByGroupsData: [],
    eventOverviewDineInDurationByGroupsError: false,

    eventOverviewGuestSizeDistributionLoading: false,
    eventOverviewGuestSizeDistributionData: [],
    eventOverviewGuestSizeDistributionError: false,

    eventOverviewDetailsLoading: false,
    eventOverviewDetailsData: [],
    eventOverviewDetailsError: false,

    eventTrendOverviewLoading: false,
    eventTrendOverviewData: [],
    eventTrendOverviewError: false,

    eventTrendLoading: false,
    eventTrendData: [],
    eventTrendError: false,

    eventTrendByGroupsLoading: false,
    eventTrendByGroupsData: [],
    eventTrendByGroupsError: false,

    eventTrendByAvgWaitTimeLoading: false,
    eventTrendByAvgWaitTimeData: [],
    eventTrendByAvgWaitTimeError: false,

    eventTrendCustomerTrendLoading: false,
    eventTrendCustomerTrendData: [],
    eventTrendCustomerTrendError: false,

    eventTrendCustomerVisitsLoading: false,
    eventTrendCustomerVisitsData: [],
    eventTrendCustomerVisitsError: false,

    // Pre-order Summary
    preOrderEventOverviewLoading: false,
    preOrderEventOverviewData: [],
    preOrderEventOverviewError: false,

    preOrderByOrderDateLoading: false,
    preOrderByOrderDateData: [],
    preOrderByOrderDateError: false,

    preOrderByPickupSlotLoading: false,
    preOrderByPickupSlotData: [],
    preOrderByPickupSlotError: false,

    preOrdersByChannelsLoading: false,
    preOrdersByChannelsData: [],
    preOrdersByChannelsError: false,

    // Pre-order Details
    preOrderDetailsLoading: false,
    preOrderDetailsData: [],
    preOrderDetailsError: false,

    // Event Name Filter Values
    eventNameFilterValuesLoading: false,
    eventNameFilterValuesSuccess: [],
    eventNameFilterValuesFailure: false,
    eventPreOrderByPickupSlotDate: null,

    eventNameGlobal:{},

    eventStartDate: null,
    eventEndDate: null,
    selectedDateFilterType: {
        label: "Last 10 Days",
        value: "Last 10 Days",
    },

    //Event Time Slots :
    eventTimeSlotsFilterLoading : false,
    eventTimeSlotsFilterSuccess : [],
    eventTimeSlotsFilterFailure : false,

    // Event Selected Time Slot :
    selectedTimeSlotForEvent: null,

    preOrderSummaryGlobalStartDate: moment().subtract(3, "months").format("YYYY-MM-DD"),
    preOrderSummaryGlobalEndDate: moment().format("YYYY-MM-DD"),
    preOrderSelectedGlobalDateFilterType : {
        label: "3 Months",
        value: "3 Months" 
    }
};


export default function eventReportsReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
               // Pre-order Summary
            case PRE_ORDER_EVENT_OVERVIEW_REQUEST:
                draft.preOrderEventOverviewLoading = true;
                draft.preOrderEventOverviewData = [];
                draft.preOrderEventOverviewError = false;
                break;
            case PRE_ORDER_EVENT_OVERVIEW_SUCCESS:
                draft.preOrderEventOverviewLoading = false;
                draft.preOrderEventOverviewData = action.payload;
                draft.preOrderEventOverviewError = false;
                break;
            case PRE_ORDER_EVENT_OVERVIEW_FAILURE:
                draft.preOrderEventOverviewLoading = false;
                draft.preOrderEventOverviewData = [];
                draft.preOrderEventOverviewError = true;
                break;

            case PRE_ORDER_BY_ORDER_DATE_REQUEST:
                draft.preOrderByOrderDateLoading = true;
                draft.preOrderByOrderDateData = [];
                draft.preOrderByOrderDateError = false;
                break;
            case PRE_ORDER_BY_ORDER_DATE_SUCCESS:
                draft.preOrderByOrderDateLoading = false;
                draft.preOrderByOrderDateData = action.payload;
                draft.preOrderByOrderDateError = false;
                break;
            case PRE_ORDER_BY_ORDER_DATE_FAILURE:
                draft.preOrderByOrderDateLoading = false;
                draft.preOrderByOrderDateData = [];
                draft.preOrderByOrderDateError = true;
                break;

            case PRE_ORDER_BY_PICKUP_SLOT_REQUEST:
                draft.preOrderByPickupSlotLoading = true;
                draft.preOrderByPickupSlotData = [];
                draft.preOrderByPickupSlotError = false;
                break;
            case PRE_ORDER_BY_PICKUP_SLOT_SUCCESS:
                draft.preOrderByPickupSlotLoading = false;
                draft.preOrderByPickupSlotData = action.payload;
                draft.preOrderByPickupSlotError = false;
                break;
            case PRE_ORDER_BY_PICKUP_SLOT_FAILURE:
                draft.preOrderByPickupSlotLoading = false;
                draft.preOrderByPickupSlotData = [];
                draft.preOrderByPickupSlotError = true;
                break;

            case PRE_ORDERS_BY_CHANNELS_REQUEST:
                draft.preOrdersByChannelsLoading = true;
                draft.preOrdersByChannelsData = [];
                draft.preOrdersByChannelsError = false;
                break;
            case PRE_ORDERS_BY_CHANNELS_SUCCESS:
                draft.preOrdersByChannelsLoading = false;
                draft.preOrdersByChannelsData = action.payload;
                draft.preOrdersByChannelsError = false;
                break;
            case PRE_ORDERS_BY_CHANNELS_FAILURE:
                draft.preOrdersByChannelsLoading = false;
                draft.preOrdersByChannelsData = [];
                draft.preOrdersByChannelsError = true;
                break;

            // Pre-order Details
            case PRE_ORDER_DETAILS_REQUEST:
                draft.preOrderDetailsLoading = true;
                draft.preOrderDetailsData = [];
                draft.preOrderDetailsError = false;
                break;
            case PRE_ORDER_DETAILS_SUCCESS:
                draft.preOrderDetailsLoading = false;
                draft.preOrderDetailsData = action.payload;
                draft.preOrderDetailsError = false;
                break;
            case PRE_ORDER_DETAILS_FAILURE:
                draft.preOrderDetailsLoading = false;
                draft.preOrderDetailsData = [];
                draft.preOrderDetailsError = true;
                break;
            // Event Name Filter Values :
            case EVENT_NAME_FILTER_VALUES_REQUEST:
                draft.eventNameFilterValuesLoading = true;
                draft.eventNameFilterValuesSuccess = [];
                draft.eventNameFilterValuesFailure = false;
                break;
            case EVENT_NAME_FILTER_VALUES_SUCCESS:
                draft.eventNameFilterValuesLoading = false;
                draft.eventNameFilterValuesSuccess = action.payload;
                draft.eventNameFilterValuesFailure = false;
                break;
            case EVENT_NAME_FILTER_VALUES_FAILURE:
                draft.eventNameFilterValuesLoading = false;
                draft.eventNameFilterValuesSuccess = [];
                draft.eventNameFilterValuesFailure = true;
                break;
    
            case EVENT_PRE_ORDER_BY_PICKUP_SLOT_DATE_REQUEST:
                draft.eventPreOrderByPickupSlotDate = action.payload;
                break;

            // Event Report Dates
            case EVENT_START_DATE:
                draft.eventStartDate = action.payload;
                break;
            case EVENT_END_DATE:
                draft.eventEndDate = action.payload;
                break;
            case EVENT_SELECTED_DATE_FILTER_TYPE:
                draft.selectedDateFilterType = action.payload;
                break;
                
            // Event Name Global
            case EVENT_NAME_GOLBAL:
                draft.eventNameGlobal = action.payload;
                break;

            // Event Time Slots :
            case EVENT_SLOTS_FILTER_REQUEST:
                draft.eventTimeSlotsFilterLoading = true;
                draft.eventTimeSlotsFilterSuccess = [];
                draft.eventTimeSlotsFilterFailure = false;
                break;
            case EVENT_SLOTS_FILTER_SUCCESS:
                draft.eventTimeSlotsFilterLoading = false;
                draft.eventTimeSlotsFilterSuccess = action.payload;
                draft.eventTimeSlotsFilterFailure = false;
                break;
            case EVENT_SLOTS_FILTER_FAILURE:
                draft.eventTimeSlotsFilterLoading = false;
                draft.eventTimeSlotsFilterSuccess = [];
                draft.eventTimeSlotsFilterFailure = true;
                break;
            
            // Event Selected Time Slot
            case EVENT_SELECTED_TIME_SLOT:
                draft.selectedTimeSlotForEvent = action.payload;
                break;

            case PRE_ORDER_SUMMARY_GLOBAL_START_DATE:
                draft.preOrderSummaryGlobalStartDate = action.payload
                break;
            
            case PRE_ORDER_SUMMARY_GLOBAL_END_DATE:
                draft.preOrderSummaryGlobalEndDate = action.payload
                break;
            
            case PRE_ORDER_SUMMARY_GLOBAL_SELECTED_DATE_FILTER_TYPE:
                draft.preOrderSelectedGlobalDateFilterType = action.payload;
                break;

            default:
                break;
        }
    })
}
